module.exports = __webpack_public_path__ + "img/Cygni_new.b3c66c0e.png";